module.exports = __webpack_public_path__ + "img/west-ham-united-logo-icon.1f996f81.png";